import React from "react"
import AuthService from '../services/authentication'

import {useOrder} from '../data/order'

import OrderDetail from "./PractitionerOrderDetail"

function OrderIndex(props) {

  let auth = AuthService.useAuth()
  const {order, isLoading, isError, mutate} = useOrder(auth.authHeader())

  if(isLoading) return <div>Loading...</div>;
  if(isError) return <div>Error occurred!</div>;

	return (
		<>
			<h2 className="text-2xl font-bold tracking-tight text-gray-900 pb-1">Review prescription</h2>
			<p>{order.patient.patient_email && `Prescription for ${order.patient.patient_email}`}</p>
			{props.currentOrderSent && <p className="font-bold">This script has been sent.</p>}
			<div className="grid grid-cols-1 md:grid-cols-4 mb-4">
				<div className="md:col-span-3">
					<OrderDetail />
	      </div>
			</div>
		</>
	)
}

export default OrderIndex